module.exports = __webpack_public_path__ + "img/IMG_2363.8bc5d730.jpg";